import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { adddocument } from "../redux/blacklist";
import { uploadBytes, getStorage, ref, getDownloadURL, getBlob, listAll } from "firebase/storage";
import { storage } from "../utilities/firebase";
import axios from "axios";

const AdditionalDocs = (props) => {
    const [files, setFiles] = useState([])
    const [showAddDoc, setShowAdd] = useState(false);
    const [showFiles, setShowFiles] = useState(false);
    const [documents, setDocs] = useState([]);

    const [filenamestring, setFileName] = useState('')

    const [IDdoc, setIDdoc] = useState('');
    const [addressdoc, setAddressDoc] = useState('');

    const [contract, setContract] = useState('');

    const [isLoading, setLoading] = useState(false);
    const [uploaded, setUploaded] = useState(false)
    const [count, setCount] = useState(0);

    const [companyadd, setCompanyAdd] = useState(false);
    const [repadd, setRepAdd] = useState(false);
    const [incidentadd, setIncidentAdd] = useState(false);
    const [additionaladd, setAdditionaladd] = useState(false);

    const dispatch = useDispatch();

    const today = new Date();

    const test_link = `http://localhost:3000/`
    const production_link = `https://apple-tree-server.vercel.app/`

   


    const updateDocs = () => {
        dispatch(adddocument({
            files
        }))
    }

    useEffect(() => {
        updateDocs()
    }, [files])

    useEffect(() => {
        setFileName(`${today.getFullYear()}${today.getMonth()+1}${today.getDate()}-`)
    },[])

    const handleDelete = (file) => {
        let index = files.indexOf(file)
        const files_copy = [...files]
        
        files_copy.splice(index, 1)

        setFiles(files_copy)
        
        setShowFiles(false)
        setTimeout(() => {
             setShowFiles(true) 
         }, 0.5)
    }

    const handleDocSubmit = async () => {
        setLoading(true);
        setUploaded(true);
        setCount(files.length);
        documents.map(async (file) => {
            await uploadFile(file[0])
            .then((res) => console.log(res))
        })
    }
    const updateDB = async () => {
        const company_id = props.company_id;
        const person_id = props.person_id;
        const incident_id = props.incident_id;
        const blacklist_id = props.blacklist_id;

        await axios.post(test_link + "documents", {
            company_id,
            person_id,
            incident_id,
            blacklist_id,
            files
        })
    }

    const handleDocUpdate = async () => {
        setLoading(true);
        setUploaded(true);
        setCount(files.length);
        await documents.map(async (file) => {
            await uploadFile(file[0])
            
        })

        await updateDB()

    }

    const uploadFile = async (file) => {
        if (file === null) return;
        const filename = file.name
        const fileRef = ref(storage, `files/${filenamestring}${filename}`);
        const data = await uploadBytes(fileRef, file).then(() => {
            return ({"response": 'File Uploaded, name: ' + filename})
        })
        .catch((err) => {
            return err
        })
        return data;
      }

    const resetFile = (id, button) => {

        setTimeout(() => {
            document.getElementById(id).type = ""
        document.getElementById(id).type = "file"
        document.getElementById(button).classList.add('disabled')
        document.getElementById(button).classList.add('btn-secondary')
        document.getElementById(button).classList.remove('btn-primary')
        }, 200)
        
    }

    return ( 
        <div >
            <div className="container d-flex justify-content-center my-3">
                <button className="btn btn-lg btn-outline-dark" onClick={(e) => {
                    e.preventDefault()
                    if (showAddDoc) {
                        setShowAdd(false)
                    } else {
                        setShowAdd(true)
                    }
                }}>Add documents</button>

            </div>
            {
                showAddDoc &&
                <div>
                   
                <div className="text-center border rounded p-5">
                <p className="text-muted lead fs-6">*After adding a document, Click on the gold ADD DOCUMENT button for each document</p>

                    <h5>Company documents</h5>
                    <label htmlFor="company-reg" className="form-label">Company registration</label>
                    <input type="file" id="company-reg" className="form-control mb-3" onChange={() => {
                        document.getElementById('company-button').classList.remove('disabled')
                        document.getElementById('company-button').classList.remove('btn-secondary')
                        document.getElementById('company-button').classList.add('btn-primary')
                    }}/>
                    {
                        companyadd &&
                        <p className="text-success mb-0">Added</p>
                    }
                    <button id="company-button" className={`btn btn-secondary mb-3 disabled`} onClick={(e) => {
                        e.preventDefault()
                        if (document.getElementById("company-reg").files[0]) {
                            setFiles((prev) => [...prev, [filenamestring + document.getElementById("company-reg").files[0].name, 'Company registration']])
                            setDocs((prev) => [...prev, [document.getElementById("company-reg").files[0], 'Company registration']])
                            setShowFiles(true)
                            setCompanyAdd(true)
                            resetFile('company-reg', 'company-button')
                        }
                        
                    }}>Add document</button>



                    <h5>Representative documents</h5>
                    <label for="ID-doc" className="form-label">ID document  <span className="text-danger">*</span></label>
                    <input id="ID-doc" name="ID-doc" className="form-control mb-3" type="file" onChange={async (e) => {
                        document.getElementById('representative-button').classList.remove('disabled')
                        document.getElementById('representative-button').classList.remove('btn-secondary')
                        document.getElementById('representative-button').classList.add('btn-primary')
                    }} />

                    <label for='address-doc' className="form-label" >Proof of Address</label>
                    <input id="address-doc" name="address-doc" className="form-control mb-3" type="file" onChange={async (e) => {
                        document.getElementById('representative-button').classList.remove('disabled')
                        document.getElementById('representative-button').classList.remove('btn-secondary')
                        document.getElementById('representative-button').classList.add('btn-primary')
                    }} />
                    {
                        repadd &&
                        <p className="text-success my-0">Added</p>
                    }
                    <button id="representative-button" className="btn btn-secondary mb-3 disabled" onClick={(e) => {
                        e.preventDefault()
                        if (document.getElementById("ID-doc").files[0]) {
                            setFiles((prev) => [...prev, [filenamestring+document.getElementById("ID-doc").files[0].name, 'ID document']])
                            setDocs((prev) => [...prev, [document.getElementById("ID-doc").files[0], 'ID document']])
                            setShowFiles(true)
                            setRepAdd(true)
                            resetFile("ID-doc", "representative-button")

                        }
                        if (document.getElementById("address-doc").files[0]) {
                            setFiles((prev) => [...prev, [filenamestring+document.getElementById("address-doc").files[0].name, 'Proof of address']])
                            setDocs((prev) => [...prev, [document.getElementById("address-doc").files[0], 'Proof of address']])
                            setShowFiles(true) 
                            setRepAdd(true)
                            resetFile("address-doc", "representative-button")

                        }
                        
                    }}>Add document</button>

                    <h5>Incident documents</h5>
                    <div>
                    <label for="" className="form-label">Contract/Agreement</label>
                    <input id="contract" name="contract" className="form-control mb-3" type="file" onChange={async (e) => {
                        document.getElementById('incident-button').classList.remove('disabled')
                        document.getElementById('incident-button').classList.remove('btn-secondary')
                        document.getElementById('incident-button').classList.add('btn-primary')
                    }} />
                    {
                        incidentadd &&
                        <p className="text-success my-0">Added</p>
                    }
                    <button id="incident-button" className="btn btn-secondary mb-3 disabled" onClick={(e) => {
                        e.preventDefault()
                        if (document.getElementById("contract").files[0]) {
                            setFiles((prev) => [...prev, [filenamestring+document.getElementById("contract").files[0].name, 'Contract/Agreement']])
                            setDocs((prev) => [...prev, [document.getElementById("contract").files[0], 'Contract/Agreement']])
                            setShowFiles(true)  
                            setIncidentAdd(true)
                            resetFile("contract", "incident-button")

                        }
                        
                    }}>Add document</button>
                    
                        </div>
                    
                    <div class="btn" data-bs-toggle="tooltip" data-bs-placement="top" title="Add multiple files by pressing 'Add document', changing details, and pressing again">
                    <h5>Addition Documents</h5>

                    <label htmlFor="files" className="form-label d-block">Upload file:</label>
                    <input type="file" id="files" className="form-control" onChange={() => {
                        document.getElementById('add-doc-button').classList.remove('disabled')
                        document.getElementById('add-doc-button').classList.remove('btn-secondary')
                        document.getElementById('add-doc-button').classList.add('btn-primary')
                    }}/>
                    <label htmlFor="type" className="form-label">Type:</label>
                    <select name="type" id="type" className="form-select">
                        <option value="Company related">Company related</option>
                        <option value="Representative related">Representative related</option>
                        <option value="Incident related">Incident related</option>
                    </select>

                    {
                        additionaladd &&
                        <p className="text-success my-0">Added</p>
                    }
                    <button id="add-doc-button" className="btn btn-secondary my-3 disabled" onClick={(e) => {
                        e.preventDefault()
                        if (document.getElementById("files").files[0]) {
                            setFiles((prev) => [...prev, [filenamestring+document.getElementById("files").files[0].name, document.getElementById('type').value]])
                            setDocs((prev) => [...prev, [document.getElementById("files").files[0], document.getElementById('type').value]])
                            setShowFiles(true)
                            setAdditionaladd(true)
                            resetFile("files", "add-doc-button")

                        }
                        
                    }}>Add document</button>
                    </div>
                    <section id="selected-files" className="my-2">
                    {
                            showFiles &&
                            
                    files.map((file) => {
                        
                        return (
                            <div className="btn-group m-1">
                                <div className="btn btn-outline-info">
                                    {file[0]} : {file[1]}
                                </div>
                                <button className="btn btn-sm btn-primary" onClick={(e) => {
                                    e.preventDefault()
                                    handleDelete(files, file)
                                }}>Delete</button>
                            </div>
                        
                    )})
                }

                    </section>
                    <p className="text-muted lead fs-6">*Press here to upload when done</p>
                    {!isLoading &&  !props.details &&
                    <button className="btn btn-lg btn-success" onClick={async (e) => {
                        e.preventDefault()
                        await handleDocSubmit()
                        .then(() => {
                            console.log('Uploaded all files')
                            setDocs([]);
                            setLoading(false)
                        })
                        
                    }}>Done</button>
                    }
                        {isLoading && 
                        <button class="btn btn-secondary" type="button" disabled>
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        Loading...
                        </button>
                        }
                    {
                        uploaded &&
                            
                        <p className="lead fs-6 text-success">Uploaded {count} files</p>

                    }
                    {
                        props.details && 
                        <button className="btn btn-lg btn-success" onClick={async (e) => {
                            e.preventDefault()
                            await handleDocUpdate()
                            .then(() => {
                                console.log('Uploaded all files')
                                setDocs([]);
                                setLoading(false)
                            })
                            
                        }}>Update</button>
                    }
                    
                </div>
                
                </div>
                
            }
            
            
        
        </div>
     );
}
 
export default AdditionalDocs;